<div class="heading">
    <h1 mat-dialog-title>Upload File</h1>

    <div>
        <button class="dialog-cancel-btn" (click)="onCancelClick()">Cancel</button>
    </div>
</div>
<img [src]="imagePath" style="height: 85%; width: 100%; overflow: hidden" />